import { lenis } from "./lenis"

function easeInOutQuart(x: number): number {
  return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
}

function easeInOutQuint(x: number): number {
  return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
}

function easeOutQuart(x: number): number {
  return 1 - Math.pow(1 - x, 4);
}

export default ref => {
  if (!ref.scrollTo) return

  ref.scrollTo.forEach(button => {
    button.addEventListener('click', () => {
      const target = document.querySelector(`[data="${button.dataset.scrollTo}"]`) as HTMLElement

      if (target) {
        lenis.scrollTo(target, { duration: 1, easing: easeOutQuart })
      }
    })
  })
}